import { render, staticRenderFns } from "./select_object_demo.vue?vue&type=template&id=170aaacd&scoped=true&"
import script from "./select_object_demo.vue?vue&type=script&lang=ts&"
export * from "./select_object_demo.vue?vue&type=script&lang=ts&"
import style0 from "./select_object_demo.vue?vue&type=style&index=0&id=170aaacd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170aaacd",
  null
  
)

export default component.exports